<template>
<div class="BatteryInfo">
    <!-- 基本信息 -->
    <div class="panel-title width-line">
        <div class="title-text">{{$t(/*基本信息*/'device.base_info')}}</div>
    </div>
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item label="IMEI">{{detail.imei}}</el-descriptions-item>
        <el-descriptions-item label="ICCID">{{detail.iccid}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*版本*/'device.version')">{{detail.version}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*DTU固件版本*/'device.dtu_software_version')">{{detail.dtu_software_version}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*BMS固件版本版本*/'device.bms_software_version')">{{detail.bms_software_version}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*生产时间*/'device.manufacture_date')">{{$U.timeFormat(detail.manufacture_date)}}</el-descriptions-item>
    </el-descriptions>
    <!-- 换行 -->
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>
    </el-descriptions>
    <!-- 位置 -->
    <div class="panel-title width-line">
        <div class="title-text">{{$t(/*位置*/'device.location')}}</div>
    </div>
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item :label="$t(/*经纬度*/'c.coordinate')">
            <el-tooltip content="点击可打开谷歌地图查看位置" placement="top-start">
                <el-button type="text" @click="routerChange('map')">{{detail.latitude}}, {{detail.longitude}}</el-button>
            </el-tooltip>
            <!-- <a target="_blank" :href="`https://www.google.com/maps?q=${detail.latitude},${detail.longitude}`">{{detail.latitude}}, {{detail.longitude}}</a> -->
        </el-descriptions-item>
        <el-descriptions-item :label="$t(/*运动方向*/'device.navigate')">{{detail.navigate}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*最后定位状态上报时间*/'device.last_gps_report_time')">{{$U.timeFormat(detail.last_gps_report_time)}}</el-descriptions-item>

        <el-descriptions-item :label="$t(/*gsm信号强度*/'device.gsm_signal_strength')">{{detail.gsm_signal_strength}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*gps信号强度*/'device.gps_signal_strength')">{{detail.gps_signal_strength}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*gps定位状态*/'device.gps_state')">{{detail.gps_state}}</el-descriptions-item>

    </el-descriptions>
    <!-- 换行 -->
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>
    </el-descriptions>
    <!-- BMS -->
    <div class="panel-title width-line">
        <div class="title-text">{{$t(/*BMS*/'device.BMS')}}</div>
    </div>
    <el-descriptions :column="3" border size="medium" class="device-descriptions" labelClassName='item-label' >
        <el-descriptions-item :span="3" labelClassName='divide-item-label' contentClassName='divide-item-content'></el-descriptions-item>

        <el-descriptions-item :label="$t(/*电压*/'device.voltage')">{{detail.voltage}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*电流*/'device.current')">{{detail.current}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*soc*/'device.soc')">{{detail.soc}}%</el-descriptions-item>

        <el-descriptions-item :label="$t(/*温度*/'device.temperature')">{{detail.temperature}}℃</el-descriptions-item>
        <el-descriptions-item :label="$t(/*剩余容量*/'device.remaining_capacity')">{{detail.remaining_capacity}}&nbsp;mAh</el-descriptions-item>
        <el-descriptions-item :label="$t(/*充满容量*/'device.full_charge_capacity')">{{detail.full_charge_capacity}}&nbsp;mAh</el-descriptions-item>

        <el-descriptions-item :label="$t(/*循环次数*/'device.cycle_count')">{{detail.cycle_count}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*额定容量*/'device.rated_capacity')">{{detail.rated_capacity}}&nbsp;mAh</el-descriptions-item>
        <el-descriptions-item :label="$t(/*额定电压*/'device.rated_voltage')">{{detail.rated_voltage}}&nbsp;mV</el-descriptions-item>

        <el-descriptions-item :label="$t(/*制造商*/'device.manufacture_name')">{{detail.manufacture_name}}</el-descriptions-item>
        <el-descriptions-item :label="$t(/*名称*/'device.name')">{{detail.name}}</el-descriptions-item>
    </el-descriptions>
</div>
</template>

<script>
export default {
    components: {},
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
        }
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        routerChange(key) {
            switch (key) {
                case 'map':
                    window.open(`https://www.google.com/maps?q=${this.detail.latitude},${this.detail.longitude}`, '_blank')
                    break;
            }
        }
    },
}
</script>

<style lang='scss'>
.BatteryInfo {
    .device-descriptions {
        .item-label {
            max-width: 240px;
        }
        .el-descriptions-item__cell{
            width: 300px;
            max-width: 400px;
        }
        .divide-item-label, .divide-item-content {
            background-color: transparent;
            border: 0;
        }
    }
}
</style>